import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { AppConfig, PopupWindow, ModalController, PostMessageAPI, StateService } from 'flux-core';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

/**
 * Post message receive event types for tolt affiliate window.
 */
export enum ToltAffiliateWindowReceiveEvent {
    SizeChange = 'phoenix:toltWindowSizeChange',
    Close = 'phoenix:toltWindowClose'
}

export const supportedLangs = [
   'ar', 'de', 'es', 'fr', 'id', 'it', 'ja', 'ko',
   'nl', 'no', 'pl', 'pt', 'ru', 'tr', 'uk', 'vi', 'zh',
];


@Component({
    selector: 'tolt-affiliate-window',
    templateUrl: './tolt-affiliate-window.cmp.html',
    styleUrls: ['./tolt-affiliate-window.cmp.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ToltAffiliateWindowComponent extends PopupWindow implements OnInit, OnDestroy {
    /**
     * An array containing all subscriptions.
     */
    protected subs: Subscription[] = [];

    constructor(
        private modalController: ModalController,
        private postMessage: PostMessageAPI,
        private translate: TranslateService,
        private state: StateService<any, any>
    ) {
        super();
    }

    public get iFrameUrl(): string {
        let siteUrl = AppConfig.get( 'SITE_URL' );
        if ( supportedLangs.includes( this.translate.currentLang )) {
            siteUrl = `${AppConfig.get( 'SITE_URL' )}${this.translate.currentLang}/`;
        }
        return `${siteUrl}tolt-in-app/`;
    }

    public ngOnInit(): void {
        this.subs.push(
            this.postMessage.recv().subscribe(message => {
                this.handleIncomingMessages(message);
            }),
        );
    }

    public ngOnDestroy(): void {
        while ( this.subs?.length > 0 ) {
            this.subs.pop().unsubscribe();
        }
    }

    public close() {
        this.modalController.hide();
    }

    /**
     * Returns the inner container of the modal window.
     */
    public getModalWindowInnerComponent(): Element {
        if ( this.state.get( 'ModalWindow' ).show ) {
            return document.getElementsByClassName( 'tolt-affiliate-window-inner' )[0];
        }
    }

    private handleIncomingMessages( message: any ): void {
        if ( !message || typeof message !== 'object' ) {
            return;
        }

        const { event } = message as any;

        if ( event === ToltAffiliateWindowReceiveEvent.SizeChange ) {
            this.handleSizeChange( message.data );
        }

        if ( event === ToltAffiliateWindowReceiveEvent.Close ) {
            this.close();
        }
    }

    /**
     * Size Change Handler
     */
    private handleSizeChange( data: any ) {
        let styles = '';

        if ( data.width ) {
            styles += `width: ${data.width}px; `;
        }

        if ( data.height ) {
            styles += `height: ${data.height}px; `;
        }

        this.getModalWindowInnerComponent().setAttribute( 'style', styles );
    }
}
